import { PageLayout } from "@ezmid/components-library";
import { useTranslation } from "react-i18next";

import { SubscriptionsListPageContent } from "../organisms/SubscriptionsListPageContent";

export function SubscriptionsListPage() {
  const { t } = useTranslation();
  return (
    <PageLayout title={t("app.page.subscriptions.heading")}>
      <SubscriptionsListPageContent />
    </PageLayout>
  );
}
